<sm-title-bar pageTitle="{{ 'employee_salary.title' | translate }}" [backWithParams]="true">
  <ng-template #addButton>
    <div class="employe_btn d-flex search-field" (click)="addSalary()">
      <button mat-flat-button color="accent">
        <mat-icon class="material-icons-round" [inline]="true">add</mat-icon>
        {{ 'employee_salary.btn_text' | translate }}

      </button>

    </div>
  </ng-template> </sm-title-bar>


<div class="row" *ngIf="!loader && salaryData.length > 0">
  <div class="col-sm-4 col-md-4 col-12" *ngFor="let data of salaryData" (click)="viewdetails(data)">
    <div class="plan-card" style="position: relative;" >
      <!-- <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options"
          style="position: absolute; right: 15px; top: 2px;">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu2="matMenu">
        <button mat-menu-item >
          <mat-icon class="material-icons-outlined">info</mat-icon>
          <span>View details</span>
        </button>
      </mat-menu> -->
      <h2 class="plan-title">{{ data.e_amount1}}</h2>
      <p class="plan-info">
        <span class="label">Salary for: </span> <span class="value">{{ data.salaryFromDate | date }} </span>,
        <span class="label">Working days: </span> <span class="value">{{ data.workingDays }} </span>
      </p>
      <!-- <p class="plan-cost">
        <span class="label">Reason: </span> <span class="value">{{ data.purpose }} </span>
      </p> -->
      <p class="plan-cost">
        <span class="label">{{data.salaryCreditDate | date}}</span>
      </p>
      <div class="arrow_right_simbol">
          <mat-icon>arrow_forward</mat-icon>
      </div>
    </div>
  </div>
</div>



<div class="row" *ngIf="!loader && salaryData.length == 0">
  <div class="col-sm-12" >
    <div style="padding: 20px 18px 20px 18px;
    border-radius: var(--dra-radius-x-small);transition: 0.3s;">
      <div class="top_section_order">
        <div class="row">
         <div class="nal_rrty">
          <div style="text-align:center;min-height: 500px;padding-top: 210px">
          <div class="cv_notifia">
         <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 480 480" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="m400 345.887-20.375-12.207A40.09 40.09 0 0 0 359.07 328h-30.664a72.366 72.366 0 0 0-18.597 2.398L217.418 355.2a32.219 32.219 0 0 0-21.754 20.176l-81.266-43.965a31.84 31.84 0 0 0-21.75-3.594 30.02 30.02 0 0 0-8.09 2.657 31.452 31.452 0 0 0-13.742 12.8 32.056 32.056 0 0 0-4.23 15.918 31.702 31.702 0 0 0 15.812 27.672l145.649 87.145A39.995 39.995 0 0 0 249.105 480h112.72a39.882 39.882 0 0 0 14.702-2.8L400 467.93V480h80V320h-80zM370.648 462.32a24.068 24.068 0 0 1-8.8 1.68H249.105a24.07 24.07 0 0 1-12.746-3.664L90.512 373.09a15.915 15.915 0 0 1-7.953-13.89 16.25 16.25 0 0 1 2.144-8 15.728 15.728 0 0 1 6.871-6.345 15.076 15.076 0 0 1 4-1.296 16.839 16.839 0 0 1 3.067-.286c2.75-.007 5.453.711 7.84 2.079l88.12 47.617c.102.488.102.969.231 1.457 3.79 13.965 16.457 23.664 30.93 23.68a78.627 78.627 0 0 0 13.183-2.352l83.117-22.242-4.125-15.457-82.847 22.144c-3.649.84-8.356 1.801-9.328 1.883a16 16 0 0 1-15.465-11.785c-.258-.969-.41-1.961-.465-2.961 0 0-.062-1.938 0-2.617a16.17 16.17 0 0 1 11.77-14.11l92.351-24.707A55.913 55.913 0 0 1 328.406 344h30.664c4.344 0 8.606 1.18 12.328 3.41L400 364.535v86.184zM416 336h48v128h-48zM329.953 64 287.04 21.09A71.5 71.5 0 0 0 236.13 0H135.55a40.273 40.273 0 0 0-17.887 4.223l-17.93 8.968a23.71 23.71 0 0 1-11.605 2.512L80 15.418V0H0v176h80v-24h13.602l4.84 3.2A88.197 88.197 0 0 0 144 169.862V272h336V64zM64 160H16V16h48zm43.297-18.113L98.398 136H80V31.426l7.543.27a40.162 40.162 0 0 0 19.344-4.192l17.914-8.969A24.046 24.046 0 0 1 135.55 16h100.578a55.622 55.622 0 0 1 39.598 16.398L307.328 64h-66.015l-19.418-19.414-11.31 11.309 56.513 56.515c6.277 6.25 6.297 16.406.047 22.688-6.254 6.277-16.41 6.297-22.688.047l-47.2-47.2-5.6 4.801c-15.466 13.133-38.071 13.469-53.923.797l-4.636-3.758-10.082 12.43 4.687 3.8A58.317 58.317 0 0 0 144 115.2v38.656a72.144 72.144 0 0 1-36.703-11.968zm113.8-7.489 12.071 12.075c12.531 12.343 32.648 12.363 45.2.039-11.743 18.183-7.11 42.383 10.519 54.941 17.629 12.559 42.015 9.031 55.363-8.004 13.348-17.039 10.938-41.562-5.477-55.672-16.41-14.109-41.02-12.816-55.859 2.934A31.463 31.463 0 0 0 285.535 112h107.13c3.44 20.129 19.206 35.895 39.335 39.336v33.328c-20.129 3.441-35.895 19.207-39.336 39.336H231.336c-3.441-20.129-19.207-35.895-39.336-39.336v-33.328a47.756 47.756 0 0 0 29.098-16.938zM288 168c0-13.254 10.746-24 24-24s24 10.746 24 24-10.746 24-24 24-24-10.746-24-24zm176 88H160V118.55a58.17 58.17 0 0 0 36-9.198L209.648 123A31.923 31.923 0 0 1 184 136h-8v64h8c17.672 0 32 14.328 32 32v8h192v-8c0-17.672 14.328-32 32-32h8v-64h-8c-17.672 0-32-14.328-32-32v-8H273.312l-16-16H464zm0 0" fill="#7c7c7c" opacity="1" data-original="#000000" class=""></path></g></svg>
          </div>
          <div>
            <p style="margin-top: 18px; color: #a8a8a8; font-size: 17px;  line-height: 24px;">
              No salary credit data to show. Check with your employer whether they started adding those records in the system. 
           </p>
         </div>
          </div>
        </div>
       </div>
      </div>
    </div>
  </div>
</div>


<!-- 
  <mat-card appearance="outlined">
    <mat-card-header class="justify-content-between align-items-center mb-3">
  
    </mat-card-header>
    <div class="rounded-3 bg-light" *ngIf="!loader">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="salaryData" [showMenuButton]="true"
        [menuDropdownTemplate]="menuTemplate">
      </sm-data-table>
    </div>
  </mat-card>
  
  
  
  <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item (click)="viewdetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
    </button>
  </ng-template>
 -->